// extracted by mini-css-extract-plugin
module.exports = {"propertyStatsWrapper":"styles_propertyStatsWrapper__h_zIB","propertySubtitle":"styles_propertySubtitle__geP-V","propertyStats":"styles_propertyStats__3eJjS"};